<template>
  <v-container fluid style="padding-top: 0; padding-bottom: 0;">
    <v-col
      cols="12"
      class="content-box d-flex flex-column custom-scroll px-0 py-6"
      style="max-height: 87vh; position: relative"
    >
      <div class="d-flex flex-row justify-space-between px-7 flex-wrap">
        <div class="sub-title">Detalle de la orden</div>
        <!--<div class="d-flex flex-row">
                    <div class="sub-title">N°</div>
                    <div class="sub-title ml-2" style="color:#6400D2 ">012889577</div>
                </div>-->
      </div>
      <div class="d-flex flex-row justify-space-between px-7 py-3 flex-wrap">
        <div class="d-flex flex-row">
          <v-icon>mdi-calendar-multiselect</v-icon>
          <div class="ml-1">Fecha de emisión</div>
          <div class="ml-1">{{ actualDate }}</div>
        </div>
        <div class="d-flex flex-row">
          <v-icon>mdi-calendar-multiselect</v-icon>
          <div class="ml-1">Fecha de vencimiento</div>
          <div class="ml-1">{{ expirationDate }}</div>
        </div>
      </div>
      <v-divider class="mx-7"></v-divider>
      <div
        class="d-flex flex-row flex-wrap px-7"
        style="flex:1; overflow-y:auto; overflow-x: hidden;"
        v-if="cartItems.items"
      >
        <v-col cols="12" md="8" class="py-0 pl-0">
          <div class="sub-title my-3" style="font-size: 20px;">Items</div>
          <div
            class="d-flex flex-row mb-8"
            v-for="(item, index) in cartItems.items"
            :key="index"
          >
            <div style="width: 86px" class="pt-2">
              <img
                v-if="item.b2b_publication.product.images[0] == null"
                :aspect-ratio="4 / 3"
                height="86"
                width="100%"
                contain
                src="../../../assets/no_image.jpg"
                alt="noImage"
              />
              <v-img
                v-else
                height="86"
                width="100%"
                contain
                :lazy-src="item.b2b_publication.product.images[0]"
                :src="item.b2b_publication.product.images[0]"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <div class="ml-6">
              <div class="name-item-order">{{ item.title }}</div>
              <div class="d-flex flex-row">
                <div class="detail-text2  mb-0">Cantidad:</div>
                <div class="amount-text2  mb-0">{{ item.quantity }}</div>
              </div>
              <div class="d-flex flex-row">
                <div class="detail-text2  mb-0">Unidad:</div>
                <div class="amount-text2  mb-0">
                  ${{ item.pvc | number_format }}
                </div>
              </div>
              <div class="d-flex flex-row">
                <div class="detail-text2  mb-0">Sub-total:</div>
                <div class="amount-text2  mb-0">
                  ${{ (item.pvc * item.quantity) | number_format }} + IVA ({{
                    item.iva
                  }}%)
                </div>
              </div>
              <div class="d-flex flex-row">
                <div class="detail-text2 mb-0">Mark UP:</div>
                <div class="amount-text2 mb-0">{{ item.mup }}%</div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex flex-column justify-end align-end py-0 pr-0 detail-amount"
        >
          <div class="detail-text mb-3">
            Descuento total: ${{ cartItems.total_discount | number_format }}
          </div>
          <div class="detail-text mb-3">
            Total IVA: ${{ cartItems.total_iva | number_format }}
          </div>
          <div class="detail-text mb-3">
            Total: ${{ cartItems.total_amount | number_format }}
          </div>
        </v-col>
      </div>
      <v-divider class="mx-7"></v-divider>
      <v-col
        cols="12"
        class="d-flex flex-row align-end justify-end pb-0 pt-4 px-7"
      >
        <v-btn
          class="outline-btn mr-3"
          @click="openCancel = true"
          :disabled="loading || confirmLoading"
          >CANCELAR</v-btn
        >
        <v-btn
          class="blue-btn"
          @click="handlerConfirmOrder"
          :disabled="loading"
          :loading="confirmLoading"
          >CONFIRMAR</v-btn
        >
      </v-col>
    </v-col>
    <simpleModal
      :active="openCancel"
      :action="handlerCancelOrder"
      :closeModal="closeModal"
      title="¿Estás seguro?"
      text="Al cancelar, todos los productos en la orden de compra serán eliminados."
      :loading="loading"
    />
    <simpleModal
      :active="openConfirm"
      :action="goToOrders"
      :closeModal="goToOrders"
      :cancelBtn="false"
      actionText="VER MI PEDIDO"
      title="¡Gracias por elegirnos!"
      text="Al momento de hacer este pedido, el stock está disponible, pero el pedido no lo reserva. 
Al momento de facturar, el stock será revalidado, le aconsejamos facturar su compra cuanto antes.
Su pedido quedará en sistema 30 días
"
    />
  </v-container>
</template>

<script>
import simpleModal from "../modals/simpleModal.vue";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    simpleModal,
  },
  data() {
    return {
      openConfirm: false,
      openCancel: false,
      actualDate: "",
      expirationDate: "",
      loading: false,
      cartId: null,
      confirmLoading: false,
      order: null,
    };
  },

  mounted() {
    this.actualDate = moment().format("DD/MM/YYYY");
    this.expirationDate = moment()
      .add(1, "month")
      .format("DD/MM/YYYY");
  },

  computed: {
    cartItems() {
      return this.$store.getters["shoppingCart/GET_CART_ITEMS"];
    },
  },

  filters: {
    number_format(
      value,
      decimals = 2,
      separatorThousands = ".",
      separatorDecimals = ","
    ) {
      let number = parseFloat(value);
      if (!isFinite(number) || (!number && number !== 0)) return "";
      let [integer, decimal] = Math.abs(number)
        .toFixed(decimals)
        .split(".");
      let length = integer.length;
      while (length > 3) {
        length -= 3;
        integer =
          integer.slice(0, length) + separatorThousands + integer.slice(length);
      }
      let sign = number < 0 ? "-" : "";
      return `${sign}${integer}${separatorDecimals}${decimal}`;
    },
  },

  methods: {
    async handlerCancelOrder() {
      this.loading = true;
      try {
        const request = {
          shopping_cart_id: this.cartItems.id,
        };
        await this.$store.dispatch("shoppingCart/EMPTY_CART", request);
        this.$router.push({ name: "purchase_order" });
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loading = false;
        this.closeModal();
      }
    },

    goToOrders() {
      this.$router.replace("order_tracking");
    },
    async handlerConfirmOrder() {
      this.confirmLoading = true;

      try {
        const order = await this.$store.dispatch(
          "shoppingCart/CONFIRM_SHOPPING_CAR",
          this.cartItems.id
        );
        console.log(order);
        this.openConfirm = true;
      } catch (error) {
        Swal.fire({
          title: "Un error ha ocurrido",
          text: "Tenemos problemas para confirmar tu compra intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      } finally {
        this.confirmLoading = false;
      }

      // this.$router.push({ name: "order_tracking" });
      // this.closeModal();
    },
    closeModal() {
      this.openCancel = false;
      this.openConfirm = false;
    },
  },
};
</script>

<style>
.content-box {
  background-color: white;
  border-radius: 10px;
}
.custom-scroll ::-webkit-scrollbar {
  width: 7px;
}
.custom-scroll ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.custom-scroll ::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
.custom-scroll ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.detail-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.blue-btn {
  height: 42px !important;
  background-color: #343ec4 !important;
  color: white !important;
  font-size: 13px !important;
}
.outline-btn {
  height: 42px !important;
  background-color: white !important;
  color: #343ec4 !important;
  border: solid 1px #343ec4;
  font-size: 13px !important;
}
.detail-text2 {
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.amount-text2 {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
  margin-left: 6px;
  text-align: center;
}
.name-item-order {
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
}
.info-text {
  font-size: 12px;
  font-weight: 600;
  color: #d32f2f;
}
.sub-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
  line-height: 26px;
}
.detail-amount {
  position: absolute;
  bottom: 104px;
  right: 30px;
}
@media (max-width: 740px) {
  .detail-amount {
    position: relative;
    bottom: 0;
    right: 0;
  }
}
</style>
